// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/v1/billing.proto" (package "viam.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { BillingService } from "./billing";
import type { CreateInvoiceAndChargeImmediatelyResponse } from "./billing";
import type { CreateInvoiceAndChargeImmediatelyRequest } from "./billing";
import type { ChargeOrganizationResponse } from "./billing";
import type { ChargeOrganizationRequest } from "./billing";
import type { UpdateLocationBillingOrganizationResponse } from "./billing";
import type { UpdateLocationBillingOrganizationRequest } from "./billing";
import type { GetLocationBillingOrganizationResponse } from "./billing";
import type { GetLocationBillingOrganizationRequest } from "./billing";
import type { UpdateOrganizationBillingTierResponse } from "./billing";
import type { UpdateOrganizationBillingTierRequest } from "./billing";
import type { GetAvailableBillingTiersResponse } from "./billing";
import type { GetAvailableBillingTiersRequest } from "./billing";
import type { SendPaymentRequiredEmailResponse } from "./billing";
import type { SendPaymentRequiredEmailRequest } from "./billing";
import type { GetInvoicePdfResponse } from "./billing";
import type { GetInvoicePdfRequest } from "./billing";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { GetInvoicesSummaryResponse } from "./billing";
import type { GetInvoicesSummaryRequest } from "./billing";
import type { GetOrgBillingInformationResponse } from "./billing";
import type { GetOrgBillingInformationRequest } from "./billing";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetCurrentMonthUsageResponse } from "./billing";
import type { GetCurrentMonthUsageRequest } from "./billing";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service viam.app.v1.BillingService
 */
export interface IBillingServiceClient {
    /**
     * Detailed breakdown of current month's costs
     *
     * @generated from protobuf rpc: GetCurrentMonthUsage(viam.app.v1.GetCurrentMonthUsageRequest) returns (viam.app.v1.GetCurrentMonthUsageResponse);
     */
    getCurrentMonthUsage(input: GetCurrentMonthUsageRequest, options?: RpcOptions): UnaryCall<GetCurrentMonthUsageRequest, GetCurrentMonthUsageResponse>;
    /**
     * Org-level information (like billing email and payment details)
     *
     * @generated from protobuf rpc: GetOrgBillingInformation(viam.app.v1.GetOrgBillingInformationRequest) returns (viam.app.v1.GetOrgBillingInformationResponse);
     */
    getOrgBillingInformation(input: GetOrgBillingInformationRequest, options?: RpcOptions): UnaryCall<GetOrgBillingInformationRequest, GetOrgBillingInformationResponse>;
    /**
     * Total outstanding balance and previous invoices
     *
     * @generated from protobuf rpc: GetInvoicesSummary(viam.app.v1.GetInvoicesSummaryRequest) returns (viam.app.v1.GetInvoicesSummaryResponse);
     */
    getInvoicesSummary(input: GetInvoicesSummaryRequest, options?: RpcOptions): UnaryCall<GetInvoicesSummaryRequest, GetInvoicesSummaryResponse>;
    /**
     * Download a PDF invoice
     *
     * @generated from protobuf rpc: GetInvoicePdf(viam.app.v1.GetInvoicePdfRequest) returns (stream viam.app.v1.GetInvoicePdfResponse);
     */
    getInvoicePdf(input: GetInvoicePdfRequest, options?: RpcOptions): ServerStreamingCall<GetInvoicePdfRequest, GetInvoicePdfResponse>;
    /**
     * Send an email with a prompt to the user's org's billing page.
     *
     * @generated from protobuf rpc: SendPaymentRequiredEmail(viam.app.v1.SendPaymentRequiredEmailRequest) returns (viam.app.v1.SendPaymentRequiredEmailResponse);
     */
    sendPaymentRequiredEmail(input: SendPaymentRequiredEmailRequest, options?: RpcOptions): UnaryCall<SendPaymentRequiredEmailRequest, SendPaymentRequiredEmailResponse>;
    /**
     * Get available billing tiers that can be assigned to organizations
     *
     * @generated from protobuf rpc: GetAvailableBillingTiers(viam.app.v1.GetAvailableBillingTiersRequest) returns (viam.app.v1.GetAvailableBillingTiersResponse);
     */
    getAvailableBillingTiers(input: GetAvailableBillingTiersRequest, options?: RpcOptions): UnaryCall<GetAvailableBillingTiersRequest, GetAvailableBillingTiersResponse>;
    /**
     * Update an organization's billing tier
     *
     * @generated from protobuf rpc: UpdateOrganizationBillingTier(viam.app.v1.UpdateOrganizationBillingTierRequest) returns (viam.app.v1.UpdateOrganizationBillingTierResponse);
     */
    updateOrganizationBillingTier(input: UpdateOrganizationBillingTierRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationBillingTierRequest, UpdateOrganizationBillingTierResponse>;
    /**
     * Get the billing organization for a location
     *
     * @generated from protobuf rpc: GetLocationBillingOrganization(viam.app.v1.GetLocationBillingOrganizationRequest) returns (viam.app.v1.GetLocationBillingOrganizationResponse);
     */
    getLocationBillingOrganization(input: GetLocationBillingOrganizationRequest, options?: RpcOptions): UnaryCall<GetLocationBillingOrganizationRequest, GetLocationBillingOrganizationResponse>;
    /**
     * Update the billing organization for a location
     *
     * @generated from protobuf rpc: UpdateLocationBillingOrganization(viam.app.v1.UpdateLocationBillingOrganizationRequest) returns (viam.app.v1.UpdateLocationBillingOrganizationResponse);
     */
    updateLocationBillingOrganization(input: UpdateLocationBillingOrganizationRequest, options?: RpcOptions): UnaryCall<UpdateLocationBillingOrganizationRequest, UpdateLocationBillingOrganizationResponse>;
    /**
     * Charge an organization on the spot
     *
     * @generated from protobuf rpc: ChargeOrganization(viam.app.v1.ChargeOrganizationRequest) returns (viam.app.v1.ChargeOrganizationResponse);
     */
    chargeOrganization(input: ChargeOrganizationRequest, options?: RpcOptions): UnaryCall<ChargeOrganizationRequest, ChargeOrganizationResponse>;
    /**
     * Deprecated: Use ChargeOrganization instead
     *
     * @generated from protobuf rpc: CreateInvoiceAndChargeImmediately(viam.app.v1.CreateInvoiceAndChargeImmediatelyRequest) returns (viam.app.v1.CreateInvoiceAndChargeImmediatelyResponse);
     */
    createInvoiceAndChargeImmediately(input: CreateInvoiceAndChargeImmediatelyRequest, options?: RpcOptions): UnaryCall<CreateInvoiceAndChargeImmediatelyRequest, CreateInvoiceAndChargeImmediatelyResponse>;
}
/**
 * @generated from protobuf service viam.app.v1.BillingService
 */
export class BillingServiceClient implements IBillingServiceClient, ServiceInfo {
    typeName = BillingService.typeName;
    methods = BillingService.methods;
    options = BillingService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Detailed breakdown of current month's costs
     *
     * @generated from protobuf rpc: GetCurrentMonthUsage(viam.app.v1.GetCurrentMonthUsageRequest) returns (viam.app.v1.GetCurrentMonthUsageResponse);
     */
    getCurrentMonthUsage(input: GetCurrentMonthUsageRequest, options?: RpcOptions): UnaryCall<GetCurrentMonthUsageRequest, GetCurrentMonthUsageResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCurrentMonthUsageRequest, GetCurrentMonthUsageResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Org-level information (like billing email and payment details)
     *
     * @generated from protobuf rpc: GetOrgBillingInformation(viam.app.v1.GetOrgBillingInformationRequest) returns (viam.app.v1.GetOrgBillingInformationResponse);
     */
    getOrgBillingInformation(input: GetOrgBillingInformationRequest, options?: RpcOptions): UnaryCall<GetOrgBillingInformationRequest, GetOrgBillingInformationResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrgBillingInformationRequest, GetOrgBillingInformationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Total outstanding balance and previous invoices
     *
     * @generated from protobuf rpc: GetInvoicesSummary(viam.app.v1.GetInvoicesSummaryRequest) returns (viam.app.v1.GetInvoicesSummaryResponse);
     */
    getInvoicesSummary(input: GetInvoicesSummaryRequest, options?: RpcOptions): UnaryCall<GetInvoicesSummaryRequest, GetInvoicesSummaryResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetInvoicesSummaryRequest, GetInvoicesSummaryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Download a PDF invoice
     *
     * @generated from protobuf rpc: GetInvoicePdf(viam.app.v1.GetInvoicePdfRequest) returns (stream viam.app.v1.GetInvoicePdfResponse);
     */
    getInvoicePdf(input: GetInvoicePdfRequest, options?: RpcOptions): ServerStreamingCall<GetInvoicePdfRequest, GetInvoicePdfResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetInvoicePdfRequest, GetInvoicePdfResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * Send an email with a prompt to the user's org's billing page.
     *
     * @generated from protobuf rpc: SendPaymentRequiredEmail(viam.app.v1.SendPaymentRequiredEmailRequest) returns (viam.app.v1.SendPaymentRequiredEmailResponse);
     */
    sendPaymentRequiredEmail(input: SendPaymentRequiredEmailRequest, options?: RpcOptions): UnaryCall<SendPaymentRequiredEmailRequest, SendPaymentRequiredEmailResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SendPaymentRequiredEmailRequest, SendPaymentRequiredEmailResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get available billing tiers that can be assigned to organizations
     *
     * @generated from protobuf rpc: GetAvailableBillingTiers(viam.app.v1.GetAvailableBillingTiersRequest) returns (viam.app.v1.GetAvailableBillingTiersResponse);
     */
    getAvailableBillingTiers(input: GetAvailableBillingTiersRequest, options?: RpcOptions): UnaryCall<GetAvailableBillingTiersRequest, GetAvailableBillingTiersResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAvailableBillingTiersRequest, GetAvailableBillingTiersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update an organization's billing tier
     *
     * @generated from protobuf rpc: UpdateOrganizationBillingTier(viam.app.v1.UpdateOrganizationBillingTierRequest) returns (viam.app.v1.UpdateOrganizationBillingTierResponse);
     */
    updateOrganizationBillingTier(input: UpdateOrganizationBillingTierRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationBillingTierRequest, UpdateOrganizationBillingTierResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateOrganizationBillingTierRequest, UpdateOrganizationBillingTierResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get the billing organization for a location
     *
     * @generated from protobuf rpc: GetLocationBillingOrganization(viam.app.v1.GetLocationBillingOrganizationRequest) returns (viam.app.v1.GetLocationBillingOrganizationResponse);
     */
    getLocationBillingOrganization(input: GetLocationBillingOrganizationRequest, options?: RpcOptions): UnaryCall<GetLocationBillingOrganizationRequest, GetLocationBillingOrganizationResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLocationBillingOrganizationRequest, GetLocationBillingOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update the billing organization for a location
     *
     * @generated from protobuf rpc: UpdateLocationBillingOrganization(viam.app.v1.UpdateLocationBillingOrganizationRequest) returns (viam.app.v1.UpdateLocationBillingOrganizationResponse);
     */
    updateLocationBillingOrganization(input: UpdateLocationBillingOrganizationRequest, options?: RpcOptions): UnaryCall<UpdateLocationBillingOrganizationRequest, UpdateLocationBillingOrganizationResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationBillingOrganizationRequest, UpdateLocationBillingOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Charge an organization on the spot
     *
     * @generated from protobuf rpc: ChargeOrganization(viam.app.v1.ChargeOrganizationRequest) returns (viam.app.v1.ChargeOrganizationResponse);
     */
    chargeOrganization(input: ChargeOrganizationRequest, options?: RpcOptions): UnaryCall<ChargeOrganizationRequest, ChargeOrganizationResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<ChargeOrganizationRequest, ChargeOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Deprecated: Use ChargeOrganization instead
     *
     * @generated from protobuf rpc: CreateInvoiceAndChargeImmediately(viam.app.v1.CreateInvoiceAndChargeImmediatelyRequest) returns (viam.app.v1.CreateInvoiceAndChargeImmediatelyResponse);
     */
    createInvoiceAndChargeImmediately(input: CreateInvoiceAndChargeImmediatelyRequest, options?: RpcOptions): UnaryCall<CreateInvoiceAndChargeImmediatelyRequest, CreateInvoiceAndChargeImmediatelyResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateInvoiceAndChargeImmediatelyRequest, CreateInvoiceAndChargeImmediatelyResponse>("unary", this._transport, method, opt, input);
    }
}
